import {LogoView} from '../view/vodin_logo_view';

import {connect} from "react-redux";


const LogoContainer=connect()(LogoView);
export default LogoContainer;